import { render, staticRenderFns } from "./EditSubCategoryForm.vue?vue&type=template&id=2f6f0bcf&scoped=true"
import script from "./EditSubCategoryForm.vue?vue&type=script&lang=js"
export * from "./EditSubCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./EditSubCategoryForm.vue?vue&type=style&index=0&id=2f6f0bcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f0bcf",
  null
  
)

export default component.exports